<template>
  <div>
    <img v-for="picpart in picparts" :bookid="bookid" :booktitle="booktitle" :chapternum="chapternum" :imgpath="picpart" :style="getImgStyle(picSplitCount)"
         v-lazy="require('../../../assets/images/loading.jpeg')"/>
    <br/>
  </div>
</template>

<script>
  import {getImg} from '../../../services/urlService'

  export default {
    name: "readpicture",
    props: {
      bookid: Number,
      booktitle: String,
      chapternum: Number,
      picparts: Array,
      picSplitCount: Number
    },
    methods: {
      getImgStyle(picSplitCount) {
        let eachPicPercent = 100 / picSplitCount;
        return `width: ${eachPicPercent}%; float: left; display: block;`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layer2/book/read-picture.vue